// @ts-check

/**
 * @template {any} M The type of this value.
 * @typedef {M extends (infer R)[] ? RecursiveOmit<R>[] : M extends Record<string, any> ? { [K in Exclude<keyof M, '$'>]: RecursiveOmit<M[K]>} : M } RecursiveOmit
 */

/**
 * @template {any} M The type of this value.
 * @param {M} obj The value to check.
 * @returns {M}
 */
export function cleanDollarFrom(obj) {
	if (Array.isArray(obj)) {
		// @ts-expect-error The types in JSDOC are not strong enough :(
		return obj.map(cleanDollarFrom);
	}

	if (!!obj && typeof obj === 'object') {
		// @ts-expect-error The types in JSDOC are not strong enough :(
		return Object.keys(obj)
			.filter((key) => key !== '$')
			.reduce((acc, key) => Object.assign(acc, { [key]: cleanDollarFrom(obj[key]) }), {});
	}
	return obj;
}
